import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {IconClose} from "../../Icon";
import {Modal, Upload} from "antd";
import {t} from "i18next";
import {
    generateUUID2,
    getImagePath,
    getImagePathSvg,
    getImagePathWithTheme, getLocalFilePath,
    imgPathPerfix, isBase64,
    isDarkMode,
    isImage
} from "@/utils";
import Dragger from "antd/es/upload/Dragger";
import {ipcInvoke} from "@/common/ipc";
import {ARRAY_DEFAULT_PROJECT_ITEM_THUMB, ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG} from "@/Const";
import global from "@/global";

let mCallback:any;
const DialogChooseThumb = forwardRef((props:{onCloseCallback:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);

    const onShowDialog = (callback:any)=>{
        setIsShowDialog(true);
        mCallback = callback;
    }

    const onPaste = (event:any)=>{
        if (!isShowDialog)return;
        // event.preventDefault();
        // 可以通过 event.clipboardData 访问剪切板数据
        var clipboardData = event.clipboardData || window.clipboardData;
        if (clipboardData.files && clipboardData.files.length > 0){
            if (clipboardData.files[0].path){
                handleCrop(clipboardData.files[0].path)
                //实际路径的图片
                // ipcInvoke('copy-file', {filePath: clipboardData.files[0].path}).then(res => {
                //     if (mCallback){
                //         mCallback("localfile://"+res);
                //     }
                // });
            }else{
                navigator.clipboard.read().then(async (clipboardItems) => {
                    for (const clipboardItem of clipboardItems) {
                        for (const type of clipboardItem.types) {
                            if (type.startsWith('image/')) {
                                const blob = await clipboardItem.getType(type);
                                const reader = new FileReader();

                                reader.onload = function(event) {
                                    const szBase64 = event.target.result;
                                    const szFileName = generateUUID2()+'.png';
                                    // 处理图片
                                    var item = {
                                        fileName:szFileName,
                                        data:szBase64.split(',')[1]
                                    }
                                    // ipcInvoke('write-base64-files',JSON.stringify([item])).then(res=>{
                                    //     if (mCallback){
                                    //         mCallback("localfile://"+szFileName);
                                    //     }
                                    // });
                                    handleCrop(szBase64);
                                };

                                reader.readAsDataURL(blob); // 转换图片为DataURL格式
                            }
                        }
                    }
                });
            }
        }
        // setIsShowDialog(false);
    }
    useEffect(()=>{
        document.body.addEventListener('paste',onPaste);
        return ()=>{
            document.body.removeEventListener('paste',onPaste);
        }
    })

    useEffect(() => {
        global.g_showDialogs['dialogChooseThumb'] = true;
        return ()=>{
            global.g_showDialogs['dialogChooseThumb'] = false;
        }
    }, []);

    useEffect(() => {
        global.g_showDialogs['dialogChooseThumb'] = isShowDialog;
    }, [isShowDialog]);

    /**
     * 处理剪切
     * @param path
     */
    const handleCrop = (path:any)=>{
        window.showDialogImageCrop(isBase64(path)?path:getLocalFilePath(path,true),(szImagePath:any)=>{
            setIsShowDialog(false);
            mCallback(szImagePath);
        });
    }

    const uploadProps:{ beforeUpload: (file) => string } = {
        beforeUpload:(file)=>{
            if (isImage(file.path)){
                handleCrop(file.path);

                // if (mCallback){
                //     //复制到文件
                //     ipcInvoke('copy-file', {filePath: file.path}).then(res => {
                //         mCallback("localfile://"+res);
                //     });
                //
                //     setIsShowDialog(false);
                // }
            }

            return Upload.LIST_IGNORE
        }
    }


    return(
        <Modal centered={true} width='760px' bodyStyle={{height:'580px'}} open={isShowDialog} closeIcon={<IconClose/>} onCancel={()=> {
            setIsShowDialog(false);
            if (props.onCloseCallback){
                props.onCloseCallback();
            }
        }}  footer={''}>
            <div style={{display: 'flex', flexDirection: 'column'}} className={'font-size-12'}>
                <span className='header-title'>{t("Change thumbnail")}</span>

                <div style={{display: 'grid', gridTemplateColumns: 'repeat(5,1fr)',gap:'22px 6px',marginTop:'22px',marginLeft:'-12px',marginRight:'-12px'}}>
                    {
                        ARRAY_DEFAULT_PROJECT_ITEM_THUMB.map((p,index) => {
                            return <div className={'flex-center cursor-pointer'} style={{overflow: 'hidden',position:'relative'}} onClick={()=>{
                                setIsShowDialog(false);
                                if (mCallback){
                                    mCallback(ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[index]);//对应的大图..
                                }
                            }}>
                                <img className={''} style={{width: '98px', height: '98px',padding:'0px'}} src={isDarkMode()?getImagePathSvg(p.replace('light','light_white').replace(".png","")):getImagePathSvg(p.replace(".png",""))}/>
                                <div className={'home-item-thumb-hover'} style={{position:"absolute",left:'50%',top:'0',width:'98px',height:'98px',transform: 'translateX(-50%)'}}></div>
                            </div>
                        })
                    }
                </div>

                <div style={{margin: '32px 16px 0px 16px',border:'1px dashed var(--border-dashed-color)',borderRadius:'8px',height:'260px'}}>
                    <Dragger {...uploadProps} accept={".jpg,.png,.bmp,.jpeg,.svg"}
                             style={{outline: 'none', background: 'transparent', border: 'none',width:'100%'}}>

                        <div className={'flex-center'}>
                           <span className="ant-upload-text">
                            <img style={{width: '26px', height: '26px'}}
                                 src={getImagePathWithTheme("thumb_upload_info")}/>
                        </span>
                            <span className={'font-family-medium ml-6'}
                                  style={{color: 'var(--drag-file-desc-color)'}}>{t("PasteImageOrClick")}</span>
                        </div>
                    </Dragger>
                </div>
            </div>
        </Modal>
    )
})

export default DialogChooseThumb;